import { render, staticRenderFns } from "./DiamondForm.vue?vue&type=template&id=4ef41ed8&"
import script from "./DiamondForm.vue?vue&type=script&lang=js&"
export * from "./DiamondForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports